import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('@/pages/home/page'));
const NotFound = lazy(() => import('@/pages/NotFound'));
const StartupCoaching = lazy(() => import('@/pages/startup-coaching/page'));
const DigitalMarketing = lazy(() => import('@/pages/digital-marketing/page'));
const WebsiteDevelopment = lazy(() => import('@/pages/website-development/page'));
const BusinessFormation = lazy(() => import('@/pages/business-formation/page'));
const BookkeepingServices = lazy(() => import('@/pages/bookkeeping-services/page'));
const PayrollServices = lazy(() => import('@/pages/payroll-services/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/startup-coaching',
    element: <StartupCoaching />,
  },
  {
    path: '/digital-marketing',
    element: <DigitalMarketing />,
  },
  {
    path: '/website-development',
    element: <WebsiteDevelopment />,
  },
  {
    path: '/business-formation',
    element: <BusinessFormation />,
  },
  {
    path: '/bookkeeping-services',
    element: <BookkeepingServices />,
  },
  {
    path: '/payroll-services',
    element: <PayrollServices />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;